export const APPOINTMENT_MISSED_GRACE_MS = 15 * 60 * 1000;

function shouldUseMissedGraceWindow(row) {
  const rawMode = String(
    row?.consultation_type || row?.mode || row?.visitType || row?.appointmentType || ""
  )
    .trim()
    .toLowerCase();

  return (
    rawMode === "private" ||
    rawMode === "virtual" ||
    rawMode === "telehealth" ||
    rawMode === "evisit"
  );
}

function toMsFromAppointment(row) {
  const rawDate = row?.appointment_date;
  if (rawDate) {
    const direct = new Date(rawDate);
    const ms = direct.getTime();
    if (Number.isFinite(ms)) return ms;
  }

  const dateISO = String(
    row?.selectedDate || row?.dateISO || row?.when?.dateISO || ""
  ).trim();
  const timeHHMM = String(
    row?.selectedTime || row?.start || row?.when?.time || "00:00"
  ).trim();

  if (!dateISO) return NaN;

  const fallback = new Date(`${dateISO}T${timeHHMM || "00:00"}:00`);
  const ms = fallback.getTime();
  return Number.isFinite(ms) ? ms : NaN;
}

export function normalizeAppointmentStatus(value) {
  return String(value || "").trim().toLowerCase();
}

export function getAppointmentLifecycleBucket(row, nowMs = Date.now()) {
  const status = normalizeAppointmentStatus(row?.status);
  const whenMs = toMsFromAppointment(row);
  const closeAfterMs = Number.isFinite(whenMs)
    ? whenMs + (shouldUseMissedGraceWindow(row) ? APPOINTMENT_MISSED_GRACE_MS : 0)
    : NaN;

  if (status === "completed" || status === "cancelled" || status === "missed" || status === "incomplete") return "past";
  if (status === "in_progress") {
    if (Number.isFinite(closeAfterMs) && nowMs >= closeAfterMs) return "past";
    return "upcoming";
  }

  if (status === "scheduled" || status === "pending") {
    if (Number.isFinite(closeAfterMs) && nowMs >= closeAfterMs) return "past";
    return "pending";
  }

  if (status === "confirmed") {
    if (Number.isFinite(closeAfterMs) && nowMs >= closeAfterMs) return "past";
    return "upcoming";
  }

  // New requests must not leak into Upcoming while the status is still
  // hydrating or coming through an older booking path.
  if (!Number.isFinite(whenMs)) return "pending";
  if (nowMs >= closeAfterMs) return "past";
  return "pending";
}

export function isPendingApprovalAppointment(row, nowMs = Date.now()) {
  return getAppointmentLifecycleBucket(row, nowMs) === "pending";
}

export function isUpcomingAppointment(row, nowMs = Date.now()) {
  return getAppointmentLifecycleBucket(row, nowMs) === "upcoming";
}

export function isPastAppointment(row, nowMs = Date.now()) {
  return getAppointmentLifecycleBucket(row, nowMs) === "past";
}
